export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 0_01.48c2cca3.jpg";